<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section workflows-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                    <core-title-section
                    [title]="'Editing: ' + workflowName"
                    [description]="'Manage your workflow stages and transitions in the editor below.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="workflow-name-edit">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
                </div>
            </header>
            <div class="workflow-name-edit-container" [hidden]="!showForm">
                <settings-workflows-edit-name-form 
                    [workflow]="workflow" 
                    (actionCancel)="onDismiss($event)" 
                    (actionSubmit)="onUpdated($event)"
                ></settings-workflows-edit-name-form>
            </div>
            <div class="box_default box_white workflows" >
                <settings-workflows-workflow
                    *ngIf="status == STATUS_DONE"
                    [workflow]="workflow"
                ></settings-workflows-workflow>
                <div class="loader">
                  <div class="dimmed" [hidden]="status == STATUS_DONE">
                    <div class="dimmed_title"></div>
                    <div class="dimmed_flex">
                      <div class="dimmed_box"></div>
                    </div>
                    <div class="dimmed_box_table"></div>
                  </div>
                </div>
            </div>

        </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
<link href="https://fonts.googleapis.com/css?family=Montserrat:300" rel="stylesheet">